import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import minecraftUrls from "../../configs/mine_craft/minecraftUrls";
import { SkinInterface } from "../../store/mine_craft/skinsSlice";

const processStrategy = (value: any) => {
  return {
    ...value,
    url: minecraftUrls.skinPath(value.id),
    thumbnail_url: minecraftUrls.remoteUrl(value.thumbnail_url),
    saven_image_url: minecraftUrls.remoteUrl(value.saven_image_url)
  };
}

const skinsEntity = new schema.Entity(
  'skins',
  {},
  {
    processStrategy
  }
);

const skinEntity = new schema.Entity(
  'skin',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { skin: SkinInterface }>(response.data.skin, skinEntity);
  return normalized.entities;
}

export const fetchSkins = createAsyncThunk(
  'skins/fetchSkins',
  async (params: object = {}) => {
    const response    = await mineCraftApi.get(`/onesky/skins`, { params })
    const normalized  = normalize<any, { skins: { [key: string]: SkinInterface } }>(response.data.skins, [skinsEntity]);

    return {
      skins: normalized.entities?.skins || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchSkin = createAsyncThunk(
  'skins/fetchSkin',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/skins/${id}`);
    return normalizeInstance(response);
  }
);

export const createSkin = createAsyncThunk(
  'skins/createSkin',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/skins`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateSkin = createAsyncThunk(
  'skins/updateSkin',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/skins/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroySkin = createAsyncThunk(
  'skins/destroySkin',
  async (id: number) => {
    const response = await mineCraftApi.delete(`/onesky/skins/${id}`);
    return response.data;
  }
);
